import { queryOptions, useQuery } from "@tanstack/react-query";

import { getCurrentUser } from "@/api/functions/auth";

// One factory for the one identity query: key + fn + staleTime co-located,
// usable from route loaders (fetchQuery / ensureQueryData) and components alike.
//
// It also backs the _authed layout's beforeLoad, which is why the staleTime
// matters: beforeLoad runs on every navigation *and* every hover-intent
// preload, so an uncached query here would fire the auth RPC per hover.
export const currentUserQueryOptions = () =>
  queryOptions({
    queryKey: ["auth", "current-user"],
    queryFn: () => getCurrentUser(),
    staleTime: 60_000,
  });

export function useCurrentUser() {
  return useQuery(currentUserQueryOptions());
}
